module.exports = __webpack_public_path__ + "media/s2Part1Model2.7429e94b.mp4";